import { supabase } from '../servicios/supabaseClient';

/* 📂 Cargar categorías desde tabla Categoria */
export async function cargarCategorias() {
  try {
    const { data, error } = await supabase
      .from('Categoria')
      .select('nombre_categoria')
      .order('nombre_categoria');

    if (error) {
      console.error('Error al cargar categorías:', error);
      throw error;
    }

    // Extraer solo los nombres de las categorías
    const categorias = data.map(cat => cat.nombre_categoria);
    
    console.log("📂 Categorías cargadas desde tabla Categoria:", categorias);
    return categorias;
  } catch (error) {
    console.error('Error en cargarCategorias:', error);
    return [];
  }
}

/* 🔍 Obtener todos los productos */
export async function obtenerProductos(pagina = 1, productosPorPagina = 6, categoria = null) {
  try {
    const inicio = (pagina - 1) * productosPorPagina;
    const fin = inicio + productosPorPagina - 1;

    let query = supabase
      .from('Productos')
      .select('*')
      .order('orden', { ascending: true }) // Ordenar por el campo orden
      .range(inicio, fin);

    // 🔍 FILTRAR POR CATEGORÍA si se especifica y no es "Todas"
    if (categoria && categoria !== "Todas") {
      query = query.eq('categoria', categoria);
    }

    const { data, error } = await query;

    if (error) {
      console.error('Error al obtener productos:', error);
      throw error;
    }

    console.log(`📦 Productos obtenidos: ${data.length} (página ${pagina}, categoría: ${categoria || 'Todas'})`);
    return data;
  } catch (error) {
    console.error('Error en obtenerProductos:', error);
    throw error;
  }
}

/* 🔢 Obtener total de productos */
export async function obtenerTotalProductos(categoria = null) {
  try {
    let query = supabase
      .from('Productos')
      .select('*', { count: 'exact', head: true });

    // 🔍 FILTRAR POR CATEGORÍA si se especifica y no es "Todas"
    if (categoria && categoria !== "Todas") {
      query = query.eq('categoria', categoria);
    }

    const { count, error } = await query;

    if (error) {
      console.error('Error al obtener total de productos:', error);
      throw error;
    }

    console.log(`Total de productos: ${count} (categoría: ${categoria || 'Todas'})`);
    return count;
  } catch (error) {
    console.error('Error en obtenerTotalProductos:', error);
    throw error;
  }
}


export async function obtenerProductosRecomendados() {
  try {
    const { data, error } = await supabase
      .from('Productos')
      .select('*')
      
      .eq('recomendado', true)
      .order('orden', { ascending: true }) 
      

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error obteniendo productos recomendados:', error);
    return [];
  }
}

/* 💰 Obtener precio de producto */
export async function getPrecioProducto(id_producto) {
  try {
    const { data, error } = await supabase
      .from('Productos')
      .select('precio, precio_oferta')
      .eq('id', id_producto)
      .single();

    if (error) throw error;

    const tieneOferta = data.precio_oferta > 0;

    return {
      precioNormal: data.precio,
      precioOferta: tieneOferta ? data.precio_oferta : null,
      enOferta: tieneOferta
    };
  } catch (error) {
    console.error('Error obteniendo precio del producto:', error);
    return {
      precioNormal: null,
      precioOferta: null,
      enOferta: false
    };
  }
}

/* 🟢 Función auxiliar: subir imagen al Storage */
async function subirImagen(file, indice = 1) {
  try {
    const fileExt = file.name.split('.').pop();
    const fileName = `${Math.random().toString(36).substring(2)}_${Date.now()}_${indice}.${fileExt}`;
    const { error: uploadError } = await supabase.storage
      .from('imagenesproductos')
      .upload(fileName, file);

    if (uploadError) throw new Error(`Error al subir imagen: ${uploadError.message}`);

    const { data: { publicUrl } } = supabase.storage
      .from('imagenesproductos')
      .getPublicUrl(fileName);

    return publicUrl;
  } catch (error) {
    console.error('⚠️ Error en subirImagen:', error);
    throw error;
  }
}

/* 🗑️ Función auxiliar: eliminar imagen del Storage */
async function eliminarImagenStorage(imagenUrl) {
  try {
    if (!imagenUrl) return;
    
    // Extraer el nombre del archivo de la URL
    const urlParts = imagenUrl.split('/');
    const fileName = urlParts[urlParts.length - 1];
    
    if (!fileName) {
      console.warn('⚠️ No se pudo extraer el nombre del archivo de la imagen:', imagenUrl);
      return;
    }

    console.log('🗑️ Intentando eliminar imagen:', fileName);

    const { error } = await supabase.storage
      .from('imagenesproductos')
      .remove([fileName]);

    if (error) {
      console.error('⚠️ Error eliminando imagen:', error.message);
      throw error;
    } else {
      console.log('✅ Imagen eliminada del storage:', fileName);
    }
  } catch (error) {
    console.error('⚠️ Error en eliminarImagenStorage:', error);
    throw error;
  }
}

/*  Agregar producto */
export async function agregarProducto(producto, archivosImagen) {
  console.log('🔄 Iniciando agregar producto:', producto);

  try {
    let imagen_url = null;
    let image_url_2 = null;

    if (archivosImagen && archivosImagen[0])
      imagen_url = await subirImagen(archivosImagen[0], 1);

    if (archivosImagen && archivosImagen[1])
      image_url_2 = await subirImagen(archivosImagen[1], 2);

    const datosProducto = {
      nombre: producto.nombre,
      descripcion: producto.descripcion || '',
      detalle: producto.detalle,
      precio: parseFloat(producto.precio) || 0,
      precio_oferta: parseFloat(producto.oferta) || 0,
      stock: parseInt(producto.stock) || 0,
      categoria: producto.categoria,
      recomendado: producto.recomendado === 'Si' || producto.recomendado === true,
      imagen_url,
      image_url_2,
      orden: parseInt(producto.orden) || 0, // Recibir el orden del usuario
    };

    console.log('📝 Insertando producto en base de datos:', datosProducto);

    const { data, error } = await supabase
      .from('Productos')
      .insert([datosProducto])
      .select();

    if (error) throw error;
    console.log('✅ Producto agregado correctamente:', data[0]);
    return data[0];
  } catch (error) {
    console.error('💥 Error completo al agregar producto:', error);
    throw error;
  }
}

/* ✏️ Editar producto */
export async function editarProducto(id, producto, archivosImagen) {
  try {
    console.log('🔄 Editando producto ID:', id);
    const productoActual = await obtenerProductoPorId(id);
    let imagen_url = productoActual.imagen_url;
    let image_url_2 = productoActual.image_url_2;

    // Subir nuevas imágenes si existen
    if (archivosImagen && archivosImagen[0]) {
      const nuevaUrl = await subirImagen(archivosImagen[0], 1);
      // Eliminar imagen anterior si existe
      if (productoActual.imagen_url) {
        await eliminarImagenStorage(productoActual.imagen_url);
      }
      imagen_url = nuevaUrl;
    }

    if (archivosImagen && archivosImagen[1]) {
      const nuevaUrl2 = await subirImagen(archivosImagen[1], 2);
      // Eliminar imagen anterior si existe
      if (productoActual.image_url_2) {
        await eliminarImagenStorage(productoActual.image_url_2);
      }
      image_url_2 = nuevaUrl2;
    }

    const datosActualizados = {
      nombre: producto.nombre,
      descripcion: producto.descripcion,
      detalle: producto.detalle,
      precio: parseFloat(producto.precio) || 0,
      precio_oferta: parseFloat(producto.oferta) || 0,
      stock: parseInt(producto.stock) || 0,
      categoria: producto.categoria,
      recomendado: producto.recomendado === 'Si' || producto.recomendado === true,
      imagen_url,
      image_url_2,
       orden: parseInt(producto.orden) || productoActual.orden // Permitir cambiar el orden
    };

    console.log('📝 Actualizando producto con datos:', datosActualizados);

    const { data, error } = await supabase
      .from('Productos')
      .update(datosActualizados)
      .eq('id', id)
      .select();

    if (error) throw error;

    console.log('✅ Producto actualizado correctamente');
    return data[0];
  } catch (error) {
    console.error('❌ Error al editar producto:', error);
    throw error;
  }
}

/* ❌ Eliminar producto */
export async function eliminarProducto(id) {
  try {
    console.log('🔥 Eliminando producto con ID:', id);
    const producto = await obtenerProductoPorId(id);

    if (!producto) {
      throw new Error('Producto no encontrado');
    }

    console.log('📷 Imágenes del producto a eliminar:', {
      imagen_url: producto.imagen_url,
      image_url_2: producto.image_url_2
    });

    // Eliminar ambas imágenes si existen
    const promesasEliminacion = [];

    if (producto.imagen_url) {
      promesasEliminacion.push(eliminarImagenStorage(producto.imagen_url));
    }

    if (producto.image_url_2) {
      promesasEliminacion.push(eliminarImagenStorage(producto.image_url_2));
    }

    // Esperar a que todas las eliminaciones de imágenes terminen
    if (promesasEliminacion.length > 0) {
      await Promise.allSettled(promesasEliminacion);
      console.log('✅ Todas las imágenes eliminadas del storage');
    }

    // Eliminar el producto de la base de datos
    const { error } = await supabase
      .from('Productos')
      .delete()
      .eq('id', id);

    if (error) throw error;
    
    console.log('✅ Producto eliminado correctamente de la base de datos');
    return true;
  } catch (error) {
    console.error('💥 Error completo en eliminarProducto:', error);
    throw error;
  }
}

/* 🔍 Obtener producto por ID */
export async function obtenerProductoPorId(id) {
  const { data, error } = await supabase
    .from('Productos')
    .select('*')
    .eq('id', id)
    .single();

  if (error) throw error;
  return data;
}

/* 🗂️ Obtener productos por categoría */
export async function obtenerProductosPorCategoria(categoria) {
  const { data, error } = await supabase
    .from('Productos')
    .select('*')
    .eq('categoria', categoria)
    .order('orden', { ascending: true }) 

  if (error) throw error;
  return data;
}
export async function obtenerProximoOrden() {
  try {
    const { data, error } = await supabase
      .from('Productos')
      .select('orden')
      .order('orden', { ascending: false })
      .limit(1)
      .single();

    if (error && error.code !== 'PGRST116') { 
      console.error('Error al obtener próximo orden:', error);
      throw error;
    }

    const maxOrden = data ? data.orden : 0;
    return maxOrden + 1;
  } catch (error) {
    console.error('Error en obtenerProximoOrden:', error);
    return 1;
  }
}
/*  Listar imágenes del Storage */
export async function listarImagenesStorage() {
  try {
    const { data, error } = await supabase.storage
      .from('imagenesproductos')
      .list('', { limit: 1000 });

    if (error) throw error;
    console.log('📷 Imágenes en storage:', data);
    return data;
  } catch (error) {
    console.error('Error al listar imágenes:', error);
    throw error;
  }
}

/* 🧹 Función para limpiar imágenes huérfanas */
export async function limpiarImagenesHuerfanas() {
  try {
    console.log('🧹 Iniciando limpieza de imágenes huérfanas...');
    
    // Obtener todas las imágenes en storage
    const imagenesStorage = await listarImagenesStorage();
    
    // Obtener todos los productos
    const productos = await obtenerProductos();
    
    // Recolectar todas las URLs de imágenes en uso
    const imagenesEnUso = new Set();
    productos.forEach(producto => {
      if (producto.imagen_url) imagenesEnUso.add(producto.imagen_url);
      if (producto.image_url_2) imagenesEnUso.add(producto.image_url_2);
    });

    // Encontrar imágenes huérfanas
    const imagenesHuerfanas = imagenesStorage.filter(imagenStorage => {
      const imagenUrl = supabase.storage
        .from('imagenesproductos')
        .getPublicUrl(imagenStorage.name).data.publicUrl;
      
      return !imagenesEnUso.has(imagenUrl);
    });

    console.log(`📊 Encontradas ${imagenesHuerfanas.length} imágenes huérfanas`);

    // Eliminar imágenes huérfanas
    if (imagenesHuerfanas.length > 0) {
      const nombresArchivos = imagenesHuerfanas.map(img => img.name);
      const { error } = await supabase.storage
        .from('imagenesproductos')
        .remove(nombresArchivos);

      if (error) throw error;
      console.log(`✅ ${imagenesHuerfanas.length} imágenes huérfanas eliminadas`);
    }

    return imagenesHuerfanas.length;
  } catch (error) {
    console.error('Error en limpiarImagenesHuerfanas:', error);
    throw error;
  }
}

/* 🔐 Login de usuario */
export async function login(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password
  });

  if (error) throw error;
  return data.user;
}

